import { ImsSettingsSchema } from "@redotech/redo-inventory-common/ims-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getImsSettings = {
  name: "getImsSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: ImsSettingsSchema,
};
